import OaApiService from './OaApiService';

export default class LeadService extends OaApiService {
  getAgentUploadedFiles(data) {
    return this.get('/FileStorageREST/all-files', data);
  }

  deleteUploadedFile(data) {
    return this.put('/FileStorageREST/agents/edit-file', data);
  }

  getLeadRecommendationsForAccount(accountid, data) {
    return this.get('/LeadREST/lead-recommendations-for-account/', data, accountid);
  }

  sendLeadEvent(data) {
    return this.post('/LeadREST/lead-event', data);
  }

  uploadFile(data) {
    return this.postRaw('/FilestorageREST/agents/save-file', data);
  }

  createCaseForLeadUpdate(data) {
    return this.put('/LeadREST/update-lead-status', data);
  }

  updateLeadStage(data, leadKey) {
    return this.put('/LeadREST/update-lead-stage', data, leadKey);
  }
}
